export function createChatId() {
  return crypto.randomUUID();
}
